import Calendar from '../store/schema/Calendar';
import { getCalendarFolder, getCalendarEntry } from '../selectors/calendarsCacheSelectors';

export default function isWritableCalendar(calendar: Calendar): boolean {
    const calendarFolder = getCalendarFolder(calendar);
    const calendarEntry: any = getCalendarEntry(calendar);
    return (
        calendarFolder &&
        calendarEntry &&
        !calendarEntry.IsReadOnly &&
        calendarFolder.EffectiveRights &&
        calendarFolder.EffectiveRights.CreateContents
    );
}
